export const AVAIL_LIFETIME = 20 * 60 * 1000; // 20 min

export const PCI_URL = 'https://secure.booking-channel.com';

export const PCI_VERSION = '6';

export const PROPERTY_MANAGEMENT_GROUP = 1;